import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_VEHICLE_COLORS](state, data) {
    state.allVehicleColors = data
  },
}
